import {create} from 'zustand';

interface CustomerAreaStore {
    creditNotes: any[];
    setCreditNotes: (creditNotes: any[]) => void;

    documents: any[];
    setDocuments: (documents: any[]) => void;
}

export const useCustomerAreaStore = create<CustomerAreaStore>((set) => ({

    creditNotes: [],
    setCreditNotes: (creditNotes) => set({ creditNotes }),

    documents: [],
    setDocuments: (documents) => set({ documents }),
}));